<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <v-app>
                        <v-container fluid>
                            <v-alert v-if="isPending" border="bottom" colored-border type="info"
                                     class="alert-warn mx-2 mt-4"
                                     elevation="2">
                                تا زمانی که اطلاعات پروفایل شما تایید نشده باشد، قادر به ثبت فرم جدید نمیباشید.
                            </v-alert>
                            <v-alert v-if="isRejected" border="bottom" colored-border type="error"
                                     class="alert-warn mx-2 mt-4"
                                     elevation="2">
                                اطلاعات پروفایل شما توسط مدیریت رد شده است. لطفا اطلاعات خود را ویرایش نمایید.
                            </v-alert>

                            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                                <v-card outlined width="100%" class="rounded-md">
                                    <v-toolbar flat>
                                        <v-tabs ref="myt" v-model="tab" align-with-title grow>
                                            <v-tabs-slider/>
                                            <v-tab>
                                                <v-icon>mdi-plus-outline</v-icon>
                                                ثبت سفارش جدید
                                            </v-tab>

                                            <v-tab>
                                                <v-icon class="m-2">mdi-basket</v-icon>
                                                سفارش ها
                                            </v-tab>
                                        </v-tabs>
                                    </v-toolbar>
                                    <v-tabs-items v-model="tab">
                                        <v-tab-item>
                                            <transition name="slide-x-transition" mode="out-in">
                                                <stepper @eventname="updateparent" ref="design" v-if="tab===0"></stepper>
                                            </transition>
                                        </v-tab-item>
                                        <v-tab-item>
                                            <order-list url="form/site/design" v-if="tab === 1"></order-list>
                                        </v-tab-item>
                                    </v-tabs-items>
                                </v-card>
                            </v-col>
                        </v-container>
                        <v-dialog
                                v-if="payDialogInfo.payments"
                                v-model="dialogPayment"
                                scrollable
                                max-width="600px"
                                max-height="200px">

                            <v-card :loading="loading" class="p-10">
                                <v-row>
                                    <v-card-title>
                                        پرداخت
                                        {{ payDialogInfo.payments.type === 'final' ? 'نهایی' : 'قسطی' }}
                                    </v-card-title>
                                    <v-spacer></v-spacer>
                                    <v-icon color="red" @click="dialogPayment=false">mdi-close</v-icon>
                                </v-row>
                                <v-divider></v-divider>


                                <v-timeline v-if="payDialogInfo.payments.type==='installment'">
                                    <v-timeline-item v-for="(x,i) in payDialogInfo.payments.transactions"
                                                     :color="x.status==='pending'?'red':'success'"
                                    >
                                        <v-card-title> {{ x.description }}</v-card-title>
                                        <div>
                                            <v-chip color="success" outlined>مبلغ قابل پرداخت:
                                                {{ persian(price(x.price)) }} ﷼
                                            </v-chip>
                                        </div>

                                        <v-btn class="btn-update" @click="pay(x.id)" :disabled="x.status!=='pending'">
                                            پرداخت
                                        </v-btn>
                                    </v-timeline-item>

                                </v-timeline>

                                <v-list two-line v-if="payDialogInfo.payments.type==='final'">
                                    <v-list-item>

                                        <v-list-item-icon>
                                            <v-icon color="indigo">
                                                mdi-currency-usd
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{
                                                    persian(price(payDialogInfo.payments.price)) + ' ریال'
                                                }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                قیمت نهایی
                                            </v-list-item-subtitle>
                                        </v-list-item-content>

                                        <v-list-item-icon class="ml-6">
                                            <v-icon color="indigo">
                                                mdi-calendar-range
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title> {{
                                                    payDialogInfo.payments.expired_at != null ? persian(jalalian(payDialogInfo.payments.expired_at)) : 'ندارد'
                                                }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                مهلت پرداخت
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>


                                    <v-list-item>

                                        <v-list-item-icon>
                                            <v-icon color="indigo">
                                                mdi-calendar-text-outline
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title> {{
                                                    payDialogInfo.payments.description != null ? payDialogInfo.payments.description : 'ندارد'
                                                }}
                                            </v-list-item-title>
                                            <v-list-item-subtitle>
                                                توضیحات
                                            </v-list-item-subtitle>
                                        </v-list-item-content>


                                    </v-list-item>


                                    <v-divider inset></v-divider>

                                    <v-list-item>


                                        <v-list-item-content>
                                            <v-list-item-title>
                                                <v-btn class="btn-buy" @click="pay" style="width: 90%">پرداخت</v-btn>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>

                                <v-card-text>


                                </v-card-text>
                            </v-card>
                        </v-dialog>
                    </v-app>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import loginRollback from "@/Utilities/LoginRollback";
import jwtService from "@/core/services/jwt.service";
import actionButton from '@/view/content/button'
import siteStatusButton from "@/view/pages/site/siteStatusButton";
import OrderList from "./orderList";
import Stepper from "./stepper";

export default {
    components: {Stepper, OrderList},
    data() {
        return {
            step: 1,
            dialogPayment: false,
            payDialogInfo: {},
            payableTransaction: null,
            selectedRows: [],
            paymentLoading: false,
            data: {
                name: null,
                type: null,
                quality: null,
                recommended_sites: [],
                rivals: [],
                programming_language: null,
                site_type: null,
                support_time: null,
            },
            dialog: false,
            loading: false,
            errorMsg: '',
            userWallet: [],
            dialogInfo: null,
            tab: null,
            items: [
                'سفارش ها',
                'ثبت سفارش جدید',
            ],
            url: 'site',
            userInfo: {},
            statusBadge: '',
            userValid: true,
            isRejected: false,
            isPending: false,
            userInfoGot: false
        }
    },
    methods: {
        paymentDialog(data) {
            this.payDialogInfo = data
            this.dialogPayment = true
        },
        getUserInfo() {
            this.userInfoGot = true;
            this.$modal.showLoading();
            this.requestApiGet('userInfo')
                .then(res => {
                    this.$modal.hideLoading();
                    let response = res.data.data
                    console.log(response.status)
                    if (response.status == 'accept') {
                        this.userValid = true
                        this.statusBadge = 'accept'
                    } else if (response.status == 'reject') {
                        this.isRejected = true
                        this.userValid = false
                        this.statusBadge = 'reject'
                        let _this = this;
                        this.$modal.error('اطلاعات تکمیلی نیاز به ویرایش دارد', 'اطلاعات شما دارای مشکل میباشد',
                            undefined,
                            {},
                            [
                                {
                                    text: "رفتن به صفحه تکمیل اطلاعات",
                                    onClick() {
                                        _this.$router.push({path: "/company-register"});
                                    }
                                }
                            ]
                        )
                    } else if (response.status == 'pending') {
                        this.isPending = true
                        this.userValid = false
                        this.statusBadge = 'pending'
                        this.$modal.warning('در انتظار تایید اطلاعات',
                            'در مرحله در انتظار تایید توسط پشتیبانی شما قادر به ثبت بیلبورد نمیباشید.')
                    } else {
                        this.userValid = false
                        this.statusBadge = ''
                        let _this = this;
                        this.$modal.info('اطلاعات خود را تکمیل کنید',
                            'تا زمانی که اطلاعات خود را تکمیل نکنید قادر به ثبت بیلبورد نمیباشید.',

                            undefined,
                            {},
                            [
                                {
                                    text: "تکمیل اطلاعات",
                                    onClick() {
                                        _this.$router.push({path: "/company-register"});
                                    }
                                }
                            ]
                        )
                    }
                })
                .catch(res => {
                    this.$modal.hideLoading();
                })
        },
        checkout(data) {
            this.$modal.showLoading();
            this.getUserTokenWithId(data.id)
                .then((token) => {
                    loginRollback.addLogin(this.getUser().name, jwtService.getToken())
                    jwtService.saveToken(token)
                    window.location.reload();
                }).catch((e) => {
                this.$toast.error("error")
            })
                .finally(() => {
                    this.$modal.hideLoading();
                })
        },
        updateparent(variable) {
            this.tab = variable
        }
    },
}

$('#select_all').click(function () {
    $('.checkBox').prop('checked', $(this).prop("checked"));
})
</script>
<style scoped>
.alert-warn {
    background-color: #CFD8DC;
}

.pending-status {
    background-color: rgb(224, 224, 94);
    padding: 0px 5px 0px 5px;
    font-weight: bold;
}

.accept-status {
    background-color: green;
    padding: 0px 5px 0px 5px;
    color: white;
    font-weight: bold;
}

.reject-status {
    background-color: red;
    padding: 0px 5px 0px 5px;
    color: white;
}
</style>
